<template>
  <div>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div v-else>
      <div class="" v-if="programSteps && programSteps.length">
        <div class="columns is-gapless has-bg-reserve has-text-white">
          <div class="column is-narrow w50p"></div>
          <div class="column columns is-gapless is-padding-top is-padding-bottom">
            <div class="column is-3 is-margin-right">
              <div>
                <span class="is-size-7 is-uppercase has-text-weight-medium">Montant total TTC attendu</span>
              </div>
              <div class="is-margin-top-small is-padding-top-xxsmall">
                <b class="is-uppercase">{{totalAmount | round(2)}} {{$currency}} TTC</b>
              </div>
            </div>
            <div class="column is-3 is-margin-right">
              <div class="is-margin-bottom-xxsmall">
                <span class="is-size-7 is-uppercase has-text-weight-medium">Total TTC Percu</span>
              </div>
              <div class="field has-addons">
                <p class="control">
                  <input class="input has-text-right is-borderless has-text-weight-bold" type="text" placeholder=""
                        id="passage-adv4-pdv-ttc" :value="totalPercu" readonly>
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3 is-margin-right">
              <div class="is-margin-bottom-xxsmall">
                <span class="is-size-7 is-uppercase has-text-weight-medium">Total TTC restant dû</span>
              </div>
              <div class="field has-addons">
                <p class="control">
                  <input class="input has-text-right is-borderless has-text-weight-bold" type="text" placeholder=""
                        id="passage-adv4-pdv-ttc" :value="totalDu | round(2)" readonly>
                </p>
                <p
                  class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin || isSectorManager" class="notification is-warning is-marginless is-min-height-75 is-flex">
          <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
            <b class="is-uppercase">Étape d'appel de fond : </b><span>Les différentes étapes d'appels de fonds se paramètrent au niveau de la fiche programme dans l'onglet "appel de fond".</span>
            <br>
            <router-link :to="{name: 'ProgramEdit', params: {id: program.pk}, query: {returnAdv: true}}" class="is-underline is-uppercase">Vous pouvez
              éditer et activer les appels de fonds uniquement pour les étapes validées au niveau de la fiche programme.
            </router-link>
          </div>
        </div>

        <div v-for="(step, idx) in advSteps" :key="idx"  :id="'e' + step.construction_step.uuid">
          <appel-de-fonds-item :source="adv"
                            :idx="idx"
                            :toOpen="toOpen"
                            :buyer="buyer"
                            :allLre="allLre"
                            :step="step"
                            :coBuyers="coBuyers"
                            @updateStep="updateStep">
          </appel-de-fonds-item>
        </div>
      </div>
      <div v-else class="is-padding">
        <div>Aucune étape présente dans la fiche du programme.</div>
        <br>
        <router-link :to="{name: 'ProgramEdit', params: {id: program.pk}}" class="button is-primary">Fiche programme
        </router-link>
      </div>
      <div class="has-bg-white is-border is-margin-top-xxsmall">
        <div class="row-width-actions-bar columns is-gapless">
          <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Commentaire</span>
          </div>
          <div class="column is-narrow is-border-left">
            <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
              class="icon is-size-4">
              <i v-if="!openComment" class="fal fa-chevron-down"></i>
              <i v-else class="fal fa-chevron-up"></i>
              </span></button>
          </div>
        </div>
        <template v-if="openComment">
          <div v-if="!openWysi" class="vadDiscussion is-border-top">
            <div
              class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div class="content" v-if="(isAdmin || isSectorManager) && adv.appel_de_fonds.comment" v-html="adv.appel_de_fonds.comment"></div>
              <div class="content" v-else-if="!(isAdmin || isSectorManager) && adv.appel_de_fonds.seller_comment" v-html="adv.appel_de_fonds.seller_comment"></div>
              <div class="content" v-else>Aucun commentaire</div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div class="">
                  <button @click="openWysiwyg" class="is-min-height-full">
                    <span class="icon is-small"><i class="fal fa-edit"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="is-border-top columns is-gapless">
            <div class="column" v-if="isAdmin || isSectorManager">
              <wysiwyg-editor
                :light='true' :tooltip-top="true"
                :model="commentaire"
                @change="val => commentaire = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="column" v-else>
              <wysiwyg-editor
                :light='true' :tooltip-top="true"
                :model="seller_commentaire"
                @change="val => seller_commentaire = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button @click="saveAdv()" type="button" class="button is-success">
                  <span class="icon is-small"><i class="fal fa-save"></i></span>
                </button>
              </div>
              <div class="">
                <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import { AdvMx } from '@/mixins'
  import AppelDeFondsItem from './AppelDeFondsItem'

  export default {
    name: 'AppelDeFonds',
    mixins: [AdvMx],
    components: { AppelDeFondsItem },
    data () {
      return {
        toOpen: null,
        loading: false,
        advSteps: [],
        openComment: true,
        openWysi: false,
        commentaire: null,
        seller_commentaire: null,
        allLre: []
      }
    },
    computed: {
      programSteps () {
        return this.program.construction_steps
      },
      totalAmount () {
        if (this.adv && this.adv.lot_sale_price && this.advSteps && this.advSteps.length) {
          let steps = this.advSteps.filter(x => x.construction_step.is_valid)
          return steps.reduce((a, b) => {
            return a + (Math.round(Number(this.adv.lot_sale_price) * Number(b.construction_step.progress)) / 100)
          }, 0)
        }
      },
      totalPercu () {
        return this.advSteps.reduce((a, b) => {
          if (b.construction_step.is_valid) {
            return a + Number(b.amount_received)
          } else return a
        }, 0)
      },
      totalDu () {
        return this.totalAmount - this.totalPercu
      }
    },
    methods: {
      refreshPage: debounce(function (val) {
        this.getLre(val)
      }, 200),
      scrollToLre: debounce(function (scrollTo) {
        setTimeout(() => {
          let container = '#app'
          this.$scrollTo(`#e${scrollTo}`, 400, {container})
        }, 200)
      }, 200),
      async getLre (scroll = false) {
        this.loading = true
        try {
          let res = await this.$api.advService.getAdfLre(this.advPk)
          this.allLre = res.data
        } catch (e) {
          this.loading = false
          console.log(e)
        } finally {
          this.loading = false
          if (scroll) {
            this.scrollToLre(scroll)
          }
        }
      },
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.appel_de_fonds.comment && !this.adv.appel_de_fonds.seller_comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.appel_de_fonds, 'comment', this.commentaire)
        this.$set(adv.appel_de_fonds, 'seller_comment', this.seller_commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      gotToProgram () {
        this.$router.push({ name: 'ProgramEdit', params: { id: this.program.pk } })
      },
      updateStep () {
        this.adv.appel_de_fonds.steps = this.advSteps
        this.commitAdv(this.adv)
      },
      checkAdvSteps () {
        let advSteps = []

        if (this.adv.appel_de_fonds.steps) {
          for (let step of this.adv.appel_de_fonds.steps.slice()) {
            let index = this.programSteps.findIndex(x => x.uuid === step.construction_step.uuid)
            if (index > -1) {
              advSteps.push(step)
            }
          }
        }
      }
    },
    created () {
      if (this.adv.appel_de_fonds.comment) this.commentaire = this.adv.appel_de_fonds.comment
      if (this.adv.appel_de_fonds.seller_comment) this.seller_commentaire = this.adv.appel_de_fonds.seller_comment
      this.advSteps = this.adv.appel_de_fonds.steps.slice()
      this.getLre()
      bus.$on(EVENTS.UPDATE_ADF_LRE, (data) => {
        console.log(data)
        this.loading = true
        this.allLre = []
        if ('adf_lre' in data && data.adf_lre) this.toOpen = data.adf_lre
        if ('step_uuid' in data && data.step_uuid) {
          this.refreshPage(data.step_uuid)
        } else {
          this.refreshPage()
        }
      })
      bus.$on(EVENTS.DELETE_ADF_LRE, (data) => {
        console.log(data)
        this.$notify({
          type: 'is-success',
          text: 'Ligne de recommandé supprimée'
        })
        this.loading = true
        this.allLre = []
        this.refreshPage()
      })
      bus.$on(EVENTS.NEW_ADF_LRE, (data) => {
        console.log(data)
        this.loading = true
        this.allLre = []
        if ('adf_lre' in data && data.adf_lre) this.toOpen = data.adf_lre
        if ('step_uuid' in data && data.step_uuid) {
          this.refreshPage(data.step_uuid)
        } else {
          this.refreshPage()
        }
      })
    },
    destroyed () {
      bus.$off([EVENTS.NEW_ADF_LRE, EVENTS.DELETE_ADF_LRE, EVENTS.UPDATE_ADF_LRE])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/AppelDeFonds.vue